import { createIcon } from '@chakra-ui/icons';

export const BakingIcon = createIcon({
  displayName: 'BakingIcon',
  viewBox: '0 0 28 29',
  d: 'M14 .832a3.333 3.333 0 110 6.667 3.333 3.333 0 010-6.667zm5.16 4.667c2.84 0 5.507 2.666 5.507 5.333 3.6 0 3.6 5.333 0 5.333H3.333c-3.6 0-3.6-5.333 0-5.333C3.333 8.165 6 5.499 8.84 5.499c.587 2.306 2.68 4 5.16 4a5.322 5.322 0 005.16-4zM4.667 18.832h4L10 28.165H7.333l-2.666-9.333zm6.666 0h5.334l-1.334 9.333h-2.666l-1.334-9.333zm8 0h4l-2.666 9.333H18l1.333-9.333z',
});
